import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// ACCUMULATOR_ISSUE_UPLOAD_ATTACHMENT

const mutation = gql`
  mutation accumulatorIssueUploadAttachment(
    $id: ID!
    $attachment: AccumulatorIssueAttachmentInput!
  ) {
    accumulatorIssueUploadAttachment(form_id: $id, attachment: $attachment) {
      id
      form_attachment {
        id
      }
    }
  }
`
export default function useAccumulatorIssueUploadAttachment() {
  const { onMutate: onAccumulatorIssueAttachmentUpload, loading } =
    useSafeRunMutation({
      mutation,
      responsePath: 'accumulatorIssueUploadAttachment',
      successMessage: 'Attachment uploaded'
    })

  return { onAccumulatorIssueAttachmentUpload, loading }
}
